import z from 'zod'

export const createEventSchema = z
  .object({
    name: z.string().trim().min(1, 'Name is required'),
    st_dt: z.iso.date('Start date is required'),
    ed_dt: z.iso.date('Enter a valid end date').nullish(),
  })
  .refine((data) => !data.ed_dt || data.ed_dt >= data.st_dt, {
    path: ['ed_dt'],
    message: 'End date must be on or after the start date',
  })
